module.exports = __webpack_public_path__ + "img/blog-2-2.88f637d8.webp";